import React, { useState } from 'react';
import * as S from './RoomChargesPanel.styled';
import CircularProgress from '@mui/material/CircularProgress';
import { SetModalContext } from 'pages/components/RightBar/RightBar';

export type RoomChargeConfirmAction =
  | 'adjust'
  | 'payAll'
  | 'deleteAll';

/** Centered confirm for pay all / delete all / adjust. */
const RoomChargeConfirm = ({
  title,
  message,
  detail,
  confirmLabel,
  isDanger,
  isCash,
  onConfirm,
}: {
  title: string,
  message: string,
  detail?: string,
  confirmLabel: string,
  isDanger?: boolean,
  isCash?: boolean,
  onConfirm: () => Promise<void> | void,
}) => {
  const { setCenterModal } = React.useContext(SetModalContext);
  const [loading, setLoading] = useState(false);

  const close = () => setCenterModal(null);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      close();
    } catch {
      // Keep confirm open on unexpected errors; action handlers toast failures.
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.ConfirmContainer>
      <S.ConfirmTitle>{title}</S.ConfirmTitle>
      <S.ConfirmMessage>{message}</S.ConfirmMessage>
      {detail ? <S.ConfirmDetail>{detail}</S.ConfirmDetail> : null}
      <S.ConfirmActions>
        <S.ConfirmCancel
          disabled={loading}
          onClick={close}
        >
          Cancel
        </S.ConfirmCancel>
        <S.ConfirmOk
          isDanger={isDanger}
          isCash={isCash}
          disabled={loading}
          onClick={() => handleConfirm()}
        >
          {loading ? (
            <CircularProgress size={14} sx={{ color: 'white' }} />
          ) : confirmLabel}
        </S.ConfirmOk>
      </S.ConfirmActions>
    </S.ConfirmContainer>
  );
};

export default RoomChargeConfirm;
